export const LogoMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <path d="M10 30 Q32 48 54 30" fill="none" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" />
    <path d="M18.8 35.8 L15 43 M27.6 38.6 L26 46.5 M36.4 38.6 L38 46.5 M45.2 35.8 L49 43" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" />
    <path className="logo-star" d="M47 6 L49.2 14.8 L58 17 L49.2 19.2 L47 28 L44.8 19.2 L36 17 L44.8 14.8 Z" fill="currentColor" />
  </svg>
);

export const Logo = ({ testId = "brand-logo" }) => (
  <a href="#top" data-testid={testId} className="group flex items-center gap-3 text-champagne">
    <LogoMark className="h-9 w-9 transition-transform duration-700 group-hover:rotate-[8deg]" />
    <span className="flex flex-col leading-none">
      <span className="font-display text-[1.35rem] tracking-[0.18em] text-cream">BEAUTY EDIT</span>
      <span className="mt-1 font-mono text-[10px] uppercase tracking-[0.32em] text-stone">by Ace Vanity</span>
    </span>
  </a>
);
